import { createSlice } from '@reduxjs/toolkit';

const insertPdfSlice = createSlice({
  name: "insertPdf",
  initialState: { insertPdfData: {} },
  reducers: {
    addPdfData(state, action) {
      const { payload } = action;
      return { insertPdfData: { ...state.insertPdfData, ...payload } };
    },
    clearInsertPdf(state, action) {
      state.insertPdfData = action.payload;
      return;
    },
  },
});

export const { addPdfData, clearInsertPdf } = insertPdfSlice.actions;
export default insertPdfSlice.reducer;